import { userSelector } from 'common/globalComponents/selectors';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Card, CardBody, FormGroup, Input, Label } from 'reactstrap';
import { createStructuredSelector } from 'reselect';
import { formatDate } from 'utils/helper';

const stateSelector = createStructuredSelector({
  user: userSelector,
});

const RecipeComments = ({ formik, keyName = 'internalComments' }) => {
  const { user } = useSelector(stateSelector);

  const getDefaultComment = () => ({
    user_id: user?.id || '',
    user_name: user?.displayName || '',
    date: '',
    comment: '',
  });

  const [newComment, setNewComment] = useState(getDefaultComment);

  useEffect(() => {
    setNewComment(getDefaultComment());
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewComment((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddComment = () => {
    if (!newComment?.comment?.trim()) return;

    const commentWithDate = {
      ...newComment,
      date: formatDate(moment(), 'DD-MMM-YYYY'),
    };

    const updatedComments = [...(formik.values[keyName] || []), commentWithDate];
    formik.setFieldValue(keyName, updatedComments);
    setNewComment(getDefaultComment());
  };

  const handleDeleteComment = (index) => {
    const updatedComments = formik.values[keyName].filter((_, i) => i !== index);
    formik.setFieldValue(keyName, updatedComments);
  };

  return (
    <Card>
      <CardBody>
        <h5 className="border-bottom pb-3">Recipe Comments</h5>

        <div className="bg-light p-4 rounded-md mt-4">
          <FormGroup>
            <Label for="comment">Comment</Label>
            <Input
              id="comment"
              name="comment"
              type="textarea"
              value={newComment.comment}
              onChange={handleChange}
              placeholder="Write a comment..."
              rows={5}
            />
          </FormGroup>

          <Button type="button" color="primary" className="mt-4" onClick={handleAddComment}>
            Add Comment
          </Button>
        </div>

        <CardBody className="mt-3">
          {formik.values[keyName] && formik.values[keyName].length > 0 ? (
            formik.values[keyName].map((c, index) => (
              <div key={`card_${index}`} className="card border mb-3">
                <div className="card-body d-flex justify-content-between align-items-center">
                  <div className="fs-6">
                    <strong>{c.user_name}</strong> <small>({c.date})</small>
                    <p className="mb-0 mt-1">{c.comment}</p>
                  </div>

                  {user?.id === c.user_id && (
                    <Button color="danger" type="button" onClick={() => handleDeleteComment(index)}>
                      <i className="fas fa-trash-alt" />
                    </Button>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="card border">
              <div className="card-body text-center py-4">
                <h6 className="mb-0">No comments yet.</h6>
              </div>
            </div>
          )}
        </CardBody>
      </CardBody>
    </Card>
  );
};

export default RecipeComments;
